export default {
  namespace: 'jobs',
  state: {
    jobUuid: '',
  },
  reducers: {
    show(state, { payload }) {
      return {
        jobUuid: payload.jobUuid,
      };
    },
    hide(state) {
      return { jobUuid: null };
    },
    setAboutInfo(state, { aboutInfo }) {
      return { aboutInfo, abd: 'sdf' };
    },
  },
};
